import { render, staticRenderFns } from "./LearningDashboard.vue?vue&type=template&id=22f0cdf1&scoped=true"
import script from "./LearningDashboard.vue?vue&type=script&lang=js"
export * from "./LearningDashboard.vue?vue&type=script&lang=js"
import style0 from "./LearningDashboard.vue?vue&type=style&index=0&id=22f0cdf1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f0cdf1",
  null
  
)

export default component.exports